import styled from 'styled-components/native'

import { Text } from 'widgets/Text'

export const FormError = styled(Text)`
  color: ${({ theme }) => theme.colors.error};
`
